import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    selectedPlan: { type: Number, default: 2 },
    selectable: Boolean
  }

  static targets = [
    'planInput',
    'submitButton'
  ]

  selectPlan(event) {
    event.preventDefault()

    if (!this.selectableValue) return

    const planSelector = event.target.closest('.plan')
    if (!planSelector) return

    this.selectedPlanValue = planSelector.dataset.planId

    // Remove selected class from all plans
    this.element.querySelectorAll('.plan').forEach(plan => {
      plan.classList.remove('selected')
    })

    // Add selected class to the clicked plan
    planSelector.classList.add('selected')
  }

  selectedPlanValueChanged() {
    // Select the plan with the current value
    const defaultPlan = this.element.querySelector(`[data-plan-id="${this.selectedPlanValue}"]`)

    // Remove selected class from all plans
    this.element.querySelectorAll('.plan').forEach(plan => {
      plan.classList.remove('selected')
    })

    // Add selected class to current plan
    if (defaultPlan) {
      defaultPlan.classList.add('selected')
    }

    // Update form and button
    if (this.hasPlanInputTarget) {
      this.planInputTarget.value = this.selectedPlanValue
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.value = this.submitButtonText()
    }
  }

  submitButtonText() {
    const planSelector = this.getSelectedPlanSelector()

    if(!planSelector) { return 'Выберите план' }

    const name = planSelector.dataset.planName

    return "включить план «" + name + "»"
  }

  getSelectedPlanSelector() {
    return this.element.querySelector('.plan.selected')
  }
}
